const e = "picture", a = "picture--fall-back", i = "picture--animation", o = "skeleton-loading", t = "image__hero", r = "image__article-quote", m = "image__promotion", c = "image__card", n = "image__masonry-card", g = "image__article-page-hero", s = "image__preview_card", l = "image__map-box", _ = "mobile", p = {
  picture: e,
  pictureFallBack: a,
  pictureAnimation: i,
  skeletonLoading: o,
  imageHero: t,
  imageArticleQuote: r,
  imagePromotion: m,
  imageCard: c,
  imageMasonryCard: n,
  imageArticlePageHero: g,
  imagePreviewCard: s,
  imageMapBox: l,
  mobile: _
};
export {
  p as i
};
//# sourceMappingURL=Image.module-8b345b58.mjs.map
